/* eslint-disable import/prefer-default-export */
import { API_URL } from '../../../../../../../utils/config';

export const IP_ALLOCATION_URL = `${API_URL}/ipallocation`;
